import { getConfigVar } from '../config';

export const AUTH_DOMAIN = getConfigVar('REACT_APP_AUTH_DOMAIN', 'rough-lake-8508.eu.auth0.com')!;
export const CLIENT_ID = getConfigVar(
  'REACT_APP_AUTH_CLIENT_ID',
  'yH2faaebr6Gb9c8TyX3sqrLHAxgv3lTu',
)!;
export const REDIRECT_URL = getConfigVar(
  'REACT_APP_AUTH_REDIRECT_URL',
  'http://localhost:3006/auth',
)!;
export const AUDIENCE = getConfigVar('REACT_APP_AUTH_AUDIENCE', 'https://coc.lacasa.care/api')!;
